import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { CookieHelper } from "../../Lib/Helper/CookieHelper";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

@ModuleName("Accessibility")
export class Accessibility implements AxInit {
    private size: number;
    private contrastMode: boolean;
    private cookieContrastMode: string;

    constructor(
        private $parent = $('body'),
        private _cookieHelper = new CookieHelper(),
        private _I18nHelper = new I18nHelper(),
        private matches = false,
    ) {
        this.size = Number(this._cookieHelper.getCookie('FontSize'))
            || Number(this.$parent.find('div[data-font-size]').attr('data-font-size'));
        this.cookieContrastMode = this._cookieHelper.getCookie('ContrastMode'),
        this.contrastMode = this.cookieContrastMode && this.cookieContrastMode === 'true'
    }

    AxInit(): void {
        const contrastMode = window.matchMedia('(forced-colors)');
        const prefersMode = window.matchMedia('(prefers-contrast)');
        const invertedColors = window.matchMedia('(inverted-colors)');
        this.matches = this.cookieContrastMode
            ? this.contrastMode
            : contrastMode.matches || prefersMode.matches || invertedColors.matches;

        const $panel = $('main').find('[data-accessibility-dropdown]').find('a');

        $panel.on('click', () => {
            $('main').find('[data-accessibility-dropdown] > div').toggleClass('opened');
            $panel.attr('aria-checked', $('main').find('[data-accessibility-dropdown] > div').hasClass('opened').toString());
        });

        $(contrastMode).on('change', (e) => {
            this.matches = this.cookieContrastMode ? this.contrastMode : e.currentTarget.matches;
            this.changeMode();
        });
        $(prefersMode).on('change', (e) => {
            this.matches = this.cookieContrastMode ? this.contrastMode : e.currentTarget.matches;
            this.changeMode();
        });
        $(invertedColors).on('change', (e) => {
            this.matches = this.cookieContrastMode ? this.contrastMode : e.currentTarget.matches;
            this.changeMode();
        });
        this.changeMode();

        this.$parent.on('change', '[data-contrast-mode]', (e) => {
            const isAutosave = $(e.currentTarget).attr('data-contrast-mode') == 'autosave';
            this.contrastMode = $(e.currentTarget).is(':checked');
            $('[data-contrast-mode]').prop('checked', this.contrastMode);
            $('body')[this.contrastMode ? 'addClass' : 'removeClass']('high-contrast');
            return isAutosave && this.persistChanges();
        });

        this.$parent.on('click', '[data-font-size-down]', (e) => {
            const isAutosave = $(e.currentTarget).attr('data-font-size-down') == 'autosave';
            const $sizeField = $('[data-font-size-down]').next('div[data-font-size]');
            if (this.size > 100) {
                this.size -= 10;
                $('html, body').css({ fontSize: `${this.size}%` });
                $sizeField.text(`${this.size}%`).attr('data-font-size', this.size);
                return isAutosave && this.persistChanges();
            }
        });

        this.$parent.on('click', '[data-font-size-up]', (e) => {
            const isAutosave = $(e.currentTarget).attr('data-font-size-up') == 'autosave';
            const $sizeField = $('[data-font-size-up]').prev('div[data-font-size]');
            this.size += 10;
            $('html, body').css({ fontSize: `${this.size}%` });
            $sizeField.text(`${this.size}%`).attr('data-font-size', this.size);
            return isAutosave && this.persistChanges();
        });

        this.$parent.on('click', '[data-accessibility-save]', () => this.persistChanges(true));
        this.$parent.on('click', '[data-accessibility-reset]', () => {
            this.size = 100;
            this.contrastMode = contrastMode.matches || prefersMode.matches || invertedColors.matches || false;
            $('html, body').css({ fontSize: `${this.size}%` });
            $('body')[this.contrastMode ? 'addClass' : 'removeClass']('high-contrast');
            $('[data-contrast-mode]').prop('checked', this.contrastMode);
            $('[data-font-size-up]').prev('div[data-font-size]').text(`${this.size}%`).attr('data-font-size', this.size);
            this._cookieHelper.eraseCookie('FontSize');
            this._cookieHelper.eraseCookie('ContrastMode');
        });

        $('.profile-nav-accesibility').on('click', () => $('[data-contrast-mode]').prop('checked', this.matches))
    }

    persistChanges(showConfirmation = false) {
        try {
            if (this.size > 100) {
                this._cookieHelper.setCookie('FontSize', this.size, 90);
            } else {
                this._cookieHelper.eraseCookie('FontSize');
            }
            this._cookieHelper.setCookie('ContrastMode', this.contrastMode, 90);
            this.cookieContrastMode = this._cookieHelper.getCookie('ContrastMode');

            if (showConfirmation) {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Success),
                    icon: 'success',
                    confirmButtonText: this._I18nHelper.GetTranslation(Translations.Ok),
                });
            }
        } catch (e) {
            if (showConfirmation) {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Error),
                    icon: 'error',
                    confirmButtonText: this._I18nHelper.GetTranslation(Translations.Ok),
                });
            }
        }
    }

    changeMode() {
        $('body')[this.matches ? 'addClass' : 'removeClass']('high-contrast');
        $('#ContrastMode, [data-contrast-mode]').prop('checked', this.matches);
        this.cookieContrastMode && this._cookieHelper.setCookie('ContrastMode', this.matches, 90);
    }
}